export type User = {
    _id: string;
    username: string;
    email: string;
    roles: Role[];
    created: string;
    archived: boolean;
    verified: boolean;
    isAnonymous: boolean;
    autoSave: boolean;
    adminId?: string;
    passwordExpirationTime: number;
    passwordCreatedAt: number;
    userConfig?: UserConfig;
};

export enum Role {
    SUPERUSER = 'SUPERUSER',
    ADMIN = 'ADMIN',
    PRESENTER = 'PRESENTER',
    CREATOR = 'CREATOR',
    VIEWER = 'VIEWER',
    USER = 'USER', // deprecated
}

export enum FILTER_USER_STATE {
    ALL = 'all',
    ARCHIVED = 'true',
    ACTIVE = 'false',
}

export type UserCredentials = {
    username: string;
    password: string;
};

export type UserCreateDTO = {
    username: string;
    email: string;
    password: string;
    repeatPassword?: string;
    isAnonymous: boolean;
    adminId: string;
    roles: Role[];
    passwordExpirationTime: number;
};

export type UserWithConnection = {
    isConnection: boolean;
    user: User;
};

export type UserConfig = {
    maxNumberOfPresentations?: number;
    maxNumberOfRooms?: number;
    maxPresentationSize?: number;
    maxNumberOfUsers?: number;
    maxGptUsage?: number;
};
